import { MenuLink } from "../../../core/until";
import { translate } from "../../../core";
import { Badge, Space } from "antd";
import { useQuery } from "@apollo/client";
import { ShowIf } from "../../../core/component";
import { GetNewOrderCountQuery } from "../graphql/order-queries.graphql";
import { DesktopOutlined } from "@ant-design/icons";

// Custom hook to share the query logic
const useNewOrderCount = () => {
  const { data } = useQuery(GetNewOrderCountQuery);
  return { newOrderCount: data?.onlineOrderNewCount ?? 0 };
};

export const OnlineOrderMenuItem = () => {
  const { newOrderCount } = useNewOrderCount();

  return (
    <Space>
      <MenuLink title={translate("online", "order")} to="/online-orders" />
      <ShowIf condition={!!newOrderCount} replacement={<></>}>
        <Badge count={newOrderCount} color="#f5222d" />
      </ShowIf>
    </Space>
  );
};

export const OnlineOrderMenuIcon = () => {
  const { newOrderCount } = useNewOrderCount();

  return (
    <>
      {newOrderCount > 0 ? (
        <DesktopOutlined style={{ fontSize: 23, color: "#f5222d" }} />
      ) : (
        <DesktopOutlined style={{ fontSize: 23, color: "#a3bde3" }} />
      )}
    </>
  );
};
